import {
  Nav,
  Panels,
  Info,
  BigText,
  MainSection,
  Marquee,
} from '../components';

import { useScroll } from '../hooks';
import { AboutStyles } from '../styles/styles';

const About = () => {
  const { scrollRef } = useScroll();

  return (
    <>
      <Nav />
      <Panels />
      <AboutStyles
        initial={{ backgroundColor: '#0f0e0e', pointerEvents: 'none' }}
        animate={{ backgroundColor: 'transparent', pointerEvents: 'unset' }}
        exit={{
          opacity: [1, 1, 0],
          transition: { duration: 2, times: [0, 0.99, 1] },
        }}
        ref={scrollRef}
        data-scroll-container>
        <BigText />
        <div data-scroll-section className="hello">
          <h1
            data-scroll
            data-scroll-speed="-8"
            data-scroll-direction="horizontal">
            Hey there! I'm...
          </h1>
        </div>
        <div data-scroll-section className="name">
          <h1 data-scroll data-scroll-speed="0.5">
            Shaquille
          </h1>
          <h3 data-scroll data-scroll-speed="6">
            Software Developer
          </h3>
          <h1 data-scroll data-scroll-speed="0.5">
            Ndunda
          </h1>
        </div>
        <MainSection />
        <Marquee />
        <div data-scroll-section className="split">
          <h1>Logic Lover</h1>
          <h1>Code Lines Matter.</h1>
        </div>
        <Info />
        <div data-scroll-section className="contact">
          <h1>Need A Dev?</h1>
          <a
            href="mailto: shaquillendunda@gmail.com"
            className="tap-highlight-transparent">
            Reach Out.
          </a>
        </div>
      </AboutStyles>
    </>
  );
};

export default About;
